import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform<T>(array: T[] | null | undefined, propertyPath: string): T[] | null | undefined {
    if (!array || !propertyPath) {
      return array;
    }

    const sortedArray = [...array];

    sortedArray.sort((itemA, itemB) => {
      const valueA = this.getNestedPropertyValue(itemA, propertyPath);
      const valueB = this.getNestedPropertyValue(itemB, propertyPath);
      return valueA - valueB;
    });

    return sortedArray;
  }

  private getNestedPropertyValue(item: unknown, propertyPath: string): number {
    const propertyKeys = propertyPath.split('.');
    let currentValue: any = item;

    for (const key of propertyKeys) {
      if (currentValue === null || currentValue === undefined) {
        return 0;
      }
      currentValue = currentValue[key];
    }

    if (typeof currentValue === 'number') {
      return currentValue;
    }

    if (typeof currentValue === 'string') {
      const parsedValue = Number(currentValue);
      if (!isNaN(parsedValue)) {
        return parsedValue;
      }
    }

    return 0;
  }
}
